import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from 'store';

export type SetTitleProps = {
    title: string;
};

const SetTitle = memo(({ title }: SetTitleProps) => {
    const dispatch = useDispatch();
    const setTitle = (newTitle: string) => dispatch(actions.layout.setTitle(newTitle));

    useEffect(() => {
        setTitle(title);
    }, [title, setTitle]);

    return null;
});

export default SetTitle;
